// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"e2bfc3ff","995":"7a20f7fd"}[chunkId] + ".chunk.js";
};